require('./blocks/program.less');



// WEBPACK FOOTER //
// ./training_programs.js